export default __webpack_public_path__ + "static/media/phone-header.54b19064.png";